module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_01c.060d30d8.jpg";